import "../styles/CabStats.scss";
import PromoteButtons from "../../Main/components/PromoteButtons";
import styles from "../../Main/main.module.scss"
import { useState } from "react";
import ModalActivity from "./modal/modalActivity";
import useGetUserProfile from "../hooks/useGetUserProfile";
import { displayNotImplemented } from "../../../shared/services/Notifications/NotificationServices";

const CabStats = ({username}: any) => {
    const { data, isLoading, error } = useGetUserProfile(username, "statistics");
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (
        <div className="CabStats_common_div">

            {/* Красное процентное свечение побед */}
            <div className="CabStats_redGlowForWinPercentage"></div>
            {/* Зеленое свечение значения эффективности */}
            <div className="CabStats_greenGlowForEffectivenessValue"></div>
            {/* Нужно letter spacing из Figma превратить в px. Формула = (font-size{Figma} * letter-spacing{Figma}) / 100 */}
            <div className="CabStats_effectiveness">Результативность</div>
            <div className="CabStats_soldier">
                <h2 className="CabStats_winPercentage">{data?.win_percentage}
                    <p className="CabStats_winPercentageValue">Процент побед</p>
                </h2>
                {/* <img className="CabStats_redArrows" src="/cabinet/redArrows.svg" /> */}
                <img className="CabStats_greenArrows" src="/cabinet/greenArrows.svg" />
                <div className="CabStats_soldier_shadow">
                    <img className="CabStats_soldierPic" src="/cabinet/soldier.png" />
                    <div className="CabStats_SoldierBackgroundShadow"></div>
                </div>
                <img className="CabStats_redArrows" src="/cabinet/redArrows.svg" />
                {/* <img className="CabStats_greenArrows" src="/cabinet/greenArrows.svg" /> */}
                <h2 className="CabStats_effectivenessValue">{data?.efficiency}
                    <p className="CabStats_effectivenessValue_2">Эффективность</p>
                </h2>
            </div>
            <div >
                <ModalActivity isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} username={username} />
                <PromoteButtons actionName='#' actionRef={false} detailsText='Открыть статистику' detailsAction={() => setIsModalOpen(true)} />
            </div>
        </div>
    );
}

export default CabStats;